import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SaisieService } from 'src/app/saisie/saisie.service';
import { FormulaireService } from '../../../formulaire.service';
import { ModeRenduService } from '../../../mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-lieux-tj',
  templateUrl: './lieux-tj.component.html',
  styleUrls: ['./lieux-tj.component.css']
})
export class LieuxTjComponent implements OnInit, OnDestroy {
  public rootForm: UntypedFormGroup;
  step: number = 0;
  @Input()
  erreursMap: Map<string, string>;
  
  private subTab: Subscription[] = [];

  private subLieuxTj: Subscription;
  private valeurTableauA4b_1: number[] = [];
  private valeurTableauA4b_2: number[] = [];
  private valeurTableauA4b_3: number[] = [];

  constructor(
    private formulaireService: FormulaireService,
    public modeRenduService: ModeRenduService,
    public saisieService: SaisieService
  ) {
    this.rootForm = this.formulaireService.getRootForm();
    if (! this.juridictions) {
      (this.rootForm.get('dg') as UntypedFormGroup).setControl('juridictions', new UntypedFormArray([]));
    }
    if (! this.lieuxTj) {
      (this.rootForm.get('moyens') as UntypedFormGroup).setControl('lieuxTj', new UntypedFormArray([]));
    }
  }

  ngOnInit(): void {
    setTimeout(() => {
      // Calcul des totaux lieux Tj
        // On maj la boucle lieuxTj avec celle de Dg juridictions
        this.subLieuxTj = this.juridictions.valueChanges.pipe(distinctUntilChanged(),debounceTime(100)).subscribe(valeur => {

          this.rootForm.get('moyens').get('aaLieuTjNb').setValue(this.rootForm.get('dg').get('xxTjNb').value);

          if (valeur instanceof Array) {

            if (this.subTab.length !== 0){
              this.subTab.forEach(element => element.unsubscribe());
            }

            this.valeurTableauA4b_1 = [];
            this.valeurTableauA4b_2 = [];
            this.valeurTableauA4b_3 = [];
            
            valeur.forEach((juridictions, index) => {
              // Maj de this.lieuxTj
              this.lieuxTj.controls[index].get('aaLieuTjRang').setValue(juridictions.xxTjRang);
              this.lieuxTj.controls[index].get('aaLieuTjIelst').setValue(juridictions.xxTjIelst);
              
              //Calcul totaux auto A4b
              this.calculAutoTotauxA4b(index, this.valeurTableauA4b_1, 'aaLieuTjNbPerm', 'aaLieuTjNbPermTot');      
              this.calculAutoTotauxA4b(index, this.valeurTableauA4b_2, 'aaLieuTjNbPermEtp', 'aaLieuTjNbPermEtpTot');      
              this.calculAutoTotauxA4b(index, this.valeurTableauA4b_3, 'aaLieuTjNbVict', 'aaLieuTjNbVictTot');      
            });
          }
        });
      this.juridictions.updateValueAndValidity();

      //Controles bloquants
      for (let index = 0; index < this.lieuxTj.length; index++) {
        this.saisieService.ajoutValidateurCroiseLieuxTj(this.lieuxTj, index);
        this.lieuxTj.controls[index].updateValueAndValidity();
      }  
    }, 1000);

  }

  ngOnDestroy(): void {
    if (this.subLieuxTj) {
      this.subLieuxTj.unsubscribe();
    }
    this.subTab.forEach(sub => { sub.unsubscribe(); });
  }

  get lieuxTj() {
    return this.rootForm.get('moyens').get('lieuxTj') as UntypedFormArray;
  }

  public get formulaire(): UntypedFormGroup {
    return this.rootForm.get('moyens') as UntypedFormGroup;
  }

  get juridictions() {
    return this.formulaireService.getRootForm().get('dg').get('juridictions') as UntypedFormArray;
  }

  public setStep(index: number): void {
    this.step = index;
  }
 
  private calculAutoTotauxA4b(index: number, tabBoucle: number[], varBoucle: string, totBoucle: string): void {
        this.subTab.push(this.lieuxTj.controls[index].get(varBoucle).valueChanges.pipe(debounceTime(100)).subscribe(valeur2 => {
              tabBoucle.splice(index,1,valeur2);
              //console.log(tabBoucle);
              let sum = tabBoucle.reduce((a,b)=>a+b,0);
              //console.log(sum);
              this.formulaire.get(totBoucle).setValue(sum);
        }));
        this.lieuxTj.controls[index].get(varBoucle).updateValueAndValidity();         
        this.formulaire.get(totBoucle).updateValueAndValidity(); 
  }

}
